import React from "react";
import { Link } from "react-router-dom";
import {
  IoMdBulb,
  IoIosCheckmarkCircle,
  IoIosRadioButtonOff,
  IoIosArrowForward,
  IoIosBook,
  IoIosCash,
  IoIosAnalytics,
} from "react-icons/io";
import Nav from "../../component/Nav";
import { AuthContext } from "../../auth/ZAuth";
import "./welcome-home.css";

const VISIT_KEY = "welcomeVisits";
const DISMISS_KEY = "onboardingDismissed";

function greetByHour() {
  const h = new Date().getHours();
  if (h < 11) return "Selamat pagi";
  if (h < 15) return "Selamat siang";
  if (h < 18) return "Selamat sore";
  return "Selamat malam";
}

function firstName(user) {
  if (!user) return "";
  const raw = user.name || user.username || "";
  return raw.split(" ")[0] || "";
}

export default function WelcomeHome(props) {
  const { user } = React.useContext(AuthContext);
  const visits = React.useMemo(() => {
    const n = parseInt(localStorage.getItem(VISIT_KEY) || "0", 10);
    return Number.isFinite(n) ? n : 0;
  }, []);

  React.useEffect(() => {
    localStorage.setItem(VISIT_KEY, String(visits + 1));
  }, [visits]);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    if (props.onDismiss) props.onDismiss();
  };

  const showSkip = visits >= 2;
  const name = firstName(user);

  return (
    <>
      <Nav icon={IoMdBulb} />
      <div className="welcome">
        <section className="welcome__hero">
        <div className="welcome__hero-eyebrow">
          {greetByHour()}
          {name && `, ${name}`}{" "}
          <span className="welcome__wave" role="img" aria-label="wave">
            👋
          </span>
        </div>
        <h1 className="welcome__hero-title">Selamat datang di Cashflow.</h1>
        <div className="welcome__hero-accent" />
      </section>

      <section className="welcome__pitch">
        <div className="welcome__triad">
          <span>Catat.</span>
          <span>Cocokkan.</span>
          <span>Pahami.</span>
        </div>
        <p className="welcome__pitch-body">
          Tiga langkah sederhana untuk memegang kendali atas uang
          Anda&nbsp;— bukan sebaliknya.
        </p>
      </section>

      <section className="welcome__steps">
        <div className="welcome__step welcome__step--done">
          <span className="welcome__step-icon">
            <IoIosCheckmarkCircle />
          </span>
          <div className="welcome__step-body">
            <div className="welcome__step-title">Akun siap</div>
            <div className="welcome__step-sub">Wallet pertama sudah dibuat</div>
          </div>
        </div>

        <Link
          to="/transaction/add"
          className="welcome__step welcome__step--action"
          onClick={() => localStorage.removeItem("walletSearch")}
        >
          <span className="welcome__step-icon welcome__step-icon--pending">
            <IoIosRadioButtonOff />
          </span>
          <div className="welcome__step-body">
            <div className="welcome__step-title">Catat transaksi pertama</div>
            <div className="welcome__step-sub">Pemasukan atau pengeluaran</div>
          </div>
          <IoIosArrowForward className="welcome__step-chev" />
        </Link>

        <Link to="/cash" className="welcome__step welcome__step--action">
          <span className="welcome__step-icon welcome__step-icon--pending">
            <IoIosRadioButtonOff />
          </span>
          <div className="welcome__step-body">
            <div className="welcome__step-title">Cocokkan dengan kas tunai</div>
            <div className="welcome__step-sub">
              Hitung uang fisik untuk kontrol selisih
            </div>
          </div>
          <IoIosArrowForward className="welcome__step-chev" />
        </Link>
      </section>

      <Link
        to="/transaction/add"
        className="welcome__cta"
        onClick={() => localStorage.removeItem("walletSearch")}
      >
        Mulai catat transaksi
      </Link>

      <div className="welcome__rule" />

      <section className="welcome__why">
        <h2 className="welcome__why-title">Apa yang membuat ini berbeda?</h2>

        <div className="welcome__why-row">
          <span className="welcome__why-icon">
            <IoIosBook />
          </span>
          <div>
            <div className="welcome__why-head">Catat semua</div>
            <div className="welcome__why-body">
              Setiap rupiah masuk-keluar dari dompet, bank, e-wallet —
              di satu tempat.
            </div>
          </div>
        </div>

        <div className="welcome__why-row">
          <span className="welcome__why-icon">
            <IoIosCash />
          </span>
          <div>
            <div className="welcome__why-head">Cocokkan dengan kenyataan</div>
            <div className="welcome__why-body">
              Hitung uang tunai Anda. Jika beda dengan catatan, mungkin
              ada transaksi yang lupa dicatat.
            </div>
          </div>
        </div>

        <div className="welcome__why-row">
          <span className="welcome__why-icon">
            <IoIosAnalytics />
          </span>
          <div>
            <div className="welcome__why-head">Pahami kebiasaan</div>
            <div className="welcome__why-body">
              Grafik bulanan menunjukkan kemana uang Anda pergi.
            </div>
          </div>
        </div>
      </section>

        {showSkip && (
          <button type="button" className="welcome__skip" onClick={dismiss}>
            Lewati pengenalan
          </button>
        )}
      </div>
    </>
  );
}
